export default {
  newDesign: true,
  parameters: {
    landing_id: "TrLquizSoft",
    segment: 46
  },
  title: "Çocuğunuzun güçlü ve zayıf yönlerini keşfedin, ücretsiz tanı alın | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  startPage: {
    title:
      "12 soruyu yanıtlayarak çocuğunuzun karşılaştığı gizli zorlukları keşfedin",
    subtitle:
      "Evde, okulda ve hayatın her alanında başarılı olmaları için özel öneriler alın.",
    image: {
      url: "/welcome/turkey_longquiz_softskills_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/turkey_longquiz_softskills_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " 🚀 Hadi Başlayalım! ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz eleştiriyi nasıl karşılıyor?",
      answers: [
        "😊 Gayet iyi karşılıyor ve kendini geliştirmeye çalışıyor",
        "😟 Üzülüyor ama hızlı bir şekilde toparlanıyor",
        "😡 Savunmaya geçiyor ya da cesareti kırılıyor",
      ],
    },
    2: {
      question: "Çocuğunuz arkadaş edinmekte ne kadar kolaylık çekiyor?",
      answers: [
        "👫 Çok kolay, dışa dönük bir yapısı var",
        "🤔 Duruma bağlı olarak bazen kolay, bazen zor oluyor",
        "😔 Zorlanıyor ve genelde yalnız hissediyor",
      ],
    },
    3: {
      question: "Çocuğunuz okulda grup etkinliklerine nasıl tepki veriyor?",
      answers: [
        "🎉 Katılmaktan keyif alıyor",
        "😐 İsteksizce katılıyor ama sonunda dahil oluyor",
        "🙅‍♂️ Grup etkinliklerinden tamamen uzak duruyor",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/turkey_longquiz_softskills_1.webp",
      subtitle: "Yanıtlarınıza göre, çocuğunuz bazı alanlarda iyi durumda, ancak bazı alanlarda desteğe ihtiyaç duyabilir. Sizin veya öğretmenlerinin desteğine güvenmesi normaldir — ancak geliştirilebilir.<br>Uzmanımızla ücretsiz bir tanı seansa katılın. Bu kişiselleştirilmiş seans, çocuğunuzun temel zorluklarını ortaya çıkaracaktır.",
      button: "🥰 Gidelim",
    },
    5: {
      question: "Çocuğunuz ödevlerini zamanında tamamlıyor mu?",
      answers: [
        "🕒 Her zaman zamanında veya erken tamamlar",
        "🤷‍♂️ Bazen tamamlar, ama ara sıra sorun yaşar",
        "🚨 Nadiren tamamlar, teslim tarihlerini hep kaçırır",
      ],
    },
    6: {
      question: "Çocuğunuz okulda başarısızlığa nasıl tepki veriyor?",
      answers: [
        "🌱 Bunu bir öğrenme fırsatı olarak görür",
        "😢 Üzülür ama tekrar dener",
        "😞 Motivasyonunu kaybeder ve vazgeçer",
      ],
    },
    7: {
      question: "Çocuğunuz okul işleri ve programında ne kadar düzenli?",
      answers: [
        "📂 Düzenli ve yapılandırılmış bir programa sahip",
        "🤔 Bazen düzenli, ama bu tutarsız olabiliyor",
        "🌀 Hiç düzenli değil — tamamen kaos içinde",
      ],
    },
    8: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/turkey_longquiz_softskills_2.webp",
      subtitle: "Bazı çocuklar kaos içinde düzen bulabilir, ancak bu istisna bir durumdur. Çocukların %85’i zaman yönetimi ve görev planlamayı öğrenmeye ihtiyaç duyar. Daha da fazlası, %90’ı, başarısızlıklarla başa çıkmayı, programlarını daha iyi organize etmeyi ve görevlerini kolayca halletmeyi öğrenmelidir. İyi haber? Bu beceriler düzenli uygulama ve doğru destekle kolayca kazanılabilir.",
      button: "🤔 İyi bilmek!",
    },
    9: {
      question: "Çocuğunuz günlük olarak cihazlarda ne kadar vakit geçiriyor?",
      answers: [
        "⏳ 2 saatten az",
        "📱 2–4 saat arası",
        "🕹️ 4 saatten fazla",
      ],
    },
    10: {
      question: "Çocuğunuz ekran süresiyle ilgili aile kurallarına ne kadar uyuyor?",
      answers: [
        "✅ Kurallara hiç sorgulamadan uyuyor",
        "🤷‍♀️ Ara sıra kuralları ihlal ediyor",
        "🚫 Kurallara hiç uymuyor ya da kurallarımız yok",
      ],
    },
    11: {
      question: "Çocuğunuz günlük sorumluluklarını ne kadar bağımsız bir şekilde yönetiyor?",
      answers: [
        "🙌 Çok bağımsız; onları kontrol etmeme gerek yok",
        "🤔 Kısmen bağımsız; bazen kontrol ediyorum",
        "🛑 Hiç bağımsız değil; her şeyi ben yönetiyorum",
      ],
    },
    12: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/turkey_longquiz_softskills_3.webp",
      subtitle: "Biliyor muydunuz? Ortalama bir çocuk günlük olarak cihazlarda 7 saatten fazla vakit geçiriyor! Bu ekran süresi, ödev, günlük rutinler veya spor gibi önemli görevleri engelleyebiliyor. Görevleri oyunlaştırmanın, katılımı önemli ölçüde artırabileceğini biliyoruz. Kanıtlanmış stratejilerimizi ücretsiz bir tanı seansı sırasında deneyin! Ama önce — son 3 soruya geçelim!",
      button: " 🚀 Hadi gidelim",
    },
    13: {
      question: "Çocuğunuz yeni şeyler denemekte ne kadar özgüvenli?",
      answers: [
        "🌟 Çok özgüvenli! Ayda 2-5 yeni şey dener",
        "🤷 Biraz özgüvenli — ara sıra yeni şeyler dener",
        "🚫 Hiç özgüvenli değil; yeni deneyimlerden kaçınır",
      ],
    },
    14: {
      question: "Çocuğunuz problem çözmeye nasıl yaklaşır?",
      answers: [
        "💡 Zorluklarla bağımsız bir şekilde başa çıkar",
        "🤝 Yardım ister ama çözmeye çalışır",
        "😔 Çabuk pes eder",
      ],
    },
    15: {
      question: "Çocuğunuz akran baskısıyla nasıl başa çıkıyor?",
      answers: [
        "💪 Güvenle kendi duruşunu savunur",
        "🤔 Bazen teslim olur ama genellikle sağlam durur",
        "😟 Çoğunlukla teslim olur ve bu konuda endişelenir",
      ],
    },
    16: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    17: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    18: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/turkey_longquiz_softskills_4.webp",
      subtitle: "Çocuğunuzun duygusal ve sosyal becerilerini anlamak, daha güçlü bir bağ kurmanıza yardımcı olur ve cihaz bağımlılığı, zorbalık ve düşük liderlik becerileri gibi sorunların üstesinden gelmeyi sağlar — bu, çocukların %57’sinde görülen yaygın bir durumdur.<br>Kodland uzmanları, her ortamda çocukların gelişimini desteklemek için duygusal düzenleme ve sosyal becerilerin geliştirilmesine odaklanır.",
      button: "Ücretsiz Seansınızı Şimdi Ayırtın",
    },
    19: {
      title: "Tebrikler! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Kaydı tamamlamak için '📆 Rezervasyon yapın' seçeneğine tıklayın.",
      button: "📆 Rezervasyon yapın",
    },
    20: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    21: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    22: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    23: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    24: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
